import ApplicationReviewPage from "./ApplicationReviewPage"

export default ApplicationReviewPage
